export const environment = {
	production: true,
	appCode: 'Chauny-admin',
	appVersion: '1',
	languages: ['en', 'fr'],
	appName: 'Chauny',
	login: {
		redirection: [''],
	},
	logout: {
		redirection: ['session', 'sign-in'],
	},
	api: {
		uri: 'https://api.chauny.appymax.com/v1',
		adminPath: '/admin',
	},
	images: {
		uri: 'https://s3.appymax.com/gergovie/',
	},
	plugins: {
		quickForm: {
			enabled: true,
		},
	},
};
